import { TimeType } from './constants'
import InputNumber from '../input-number'

export default {
  name: 'KTimePickerCell',
  inject: ['context', 'picker'],
  props: {
    value: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      innerValue: '',
    }
  },
  computed: {
    active() {
      return this.context.active
    },
    meta() {
      return TimeType[this.type] || {}
    },
    min() {
      return this.meta.min
    },
    max() {
      return this.meta.max
    },
    unit() {
      return this.meta.unit
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.innerValue = this.value
      },
    },
    innerValue: {
      immediate: true,
      handler(value) {
        this.$emit('input', value)
      },
    },
    active(value) {
      if (this.type === 'hour') {
        console.log('active: ', value)
      }
    },
  },
  created() {

  },
  methods: {},
  render() {
    const { min, max } = this

    const css = {
      'km-time-picker__cell': true,
      [`km-time-picker--${this.type}`]: true,
    }

    const props = {
      buttonPosition: 'right',
      value: +this.innerValue,
      size: 'large',
      loop: true,
      min: min,
      max: max,
      showButtonOnHover: true,
      formatter(value) {
        return `${value}`.length < 2 ? `0${value}` : `${value}`
      },
      parse(value) {
        return +`${value}`
      },
    }

    const events = {
      input: (value) => {
        this.innerValue = value
      },
    }

    const data = {
      class: css,
      props,
      on: events,
    }

    return (
      <InputNumber
        ref="inputNumber"
        {...data}
      >
      </InputNumber>
    )
  },

}
